module.exports = __webpack_public_path__ + "static/media/06.8ce272bd.jpg";